class BaseStore {
  get(key, type, defaultVal) {
    try {
      let value = this.getStore()[key];
      if (typeof value === 'undefined') {
        return defaultVal;
      }

      switch (type) {
        case 'object':
          return JSON.parse(value || '{}');
        case 'string':
          if (value.length <= 0) {
            return defaultVal;
          }
          return value;
        case 'number':
          if (isNaN(parseInt(value))) {
            return defaultVal;
          }
          return +value;
      }
    } catch (e) {
      return defaultVal;
    }
  }

  put(key, value) {
    if (typeof value === 'object') {
      this.getStore().setItem(key, JSON.stringify(value));
    } else {
      this.getStore().setItem(key, value);
    }
  }
}

export const LocalStore = new (class Class extends BaseStore {
  getStore() {
    return localStorage;
  }
})();

export const SessionStore = new (class Class extends BaseStore {
  getStore() {
    return sessionStorage;
  }
})();
